import React from 'react';
import styled from 'styled-components';
import searchImage from 'images/search.png';

const NoResultsFound: React.FC = () => {
  return (
    <Container>
      <Content>
        <img src={searchImage} width={158} height={158} alt="No results found" />
        <TextBlock>
          <Title>No results found</Title>
          <Subtitle>Try a different search request or select other filters</Subtitle>
        </TextBlock>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 410px;
  margin-top: 16px;
  background-color: ${(props) => props.theme.colors.primaryWhite};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Title = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primaryBlack};
`;

const Subtitle = styled.span`
  font-size: 14px;
  color: #666666;
`;

export default NoResultsFound;
